module.exports = __webpack_public_path__ + "static/media/cv.3081ee51.webp";